<form [formGroup]="form">
  <ng-container formGroupName="template">
    <ng-container *ngTemplateOutlet="sectionHeader; context: { label: 'header', optional: true }"></ng-container>
    <div formGroupName="header" class="header">
      <app-kakaotalk-template-media-header
        [form]="$any(form.get('template.header'))"></app-kakaotalk-template-media-header>
    </div>

    <ng-container *ngTemplateOutlet="sectionHeader; context: { label: 'body' }"></ng-container>
    <p class="body">
      <mat-form-field appearance="outline">
        <textarea
          #bodyText
          matInput
          formControlName="body"
          [maxlength]="limitations.maxLength.body"
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="3"></textarea>
        <span class="text-muted" matSuffix>{{ bodyText.value?.length || 0 }}/{{ limitations.maxLength.body }}</span>
        <mat-error
          *ngIf="body.hasError('tooManyPlaceholders')"
          [translate]="'parameters/kakaotalk-templates/content/body/placeholders/errors'"
          [translateParams]="{ i: limitations.maxNumber.placeholders }">
        </mat-error>
        <mat-hint translate="parameters/kakaotalk-templates/content/body/placeholders/hint"></mat-hint>
      </mat-form-field>
    </p>
    <div class="placeholders-container" *ngIf="placeholdersControls?.length" formGroupName="placeholders">
      <p class="description" [translate]="'parameters/kakaotalk-templates/content/body/placeholders/description'"></p>
      <p *ngFor="let placeholder of placeholdersControls; index as i" formGroupName="{{ placeholder }}">
        <mat-form-field>
          <mat-label
            [translate]="'parameters/kakaotalk-templates/content/body/placeholders/label'"
            [translateParams]="{ i: placeholder }"></mat-label>
          <input matInput formControlName="label" />
        </mat-form-field>
      </p>
    </div>

    <ng-container *ngTemplateOutlet="sectionHeader; context: { label: 'buttons', optional: true }"></ng-container>
    <ng-container *ngIf="form.enabled">
      <p class="text-muted" [translate]="'parameters/kakaotalk-templates/content/buttons/description-2'"></p>
    </ng-container>

    <div cdkDropList (cdkDropListDropped)="drop($event)" class="buttons-container">
      <div *ngFor="let section of sections" class="sections" cdkDrag [cdkDragData]="section">
        <div class="button-group-title">
          <div class="section-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </div>
          <div class="section-placeholder" *cdkDragPlaceholder></div>

          <mat-icon> {{ section.titleIcon }} </mat-icon>
          <span [translate]="section.titleKey"></span>
        </div>
        <ng-template
          *ngTemplateOutlet="
            buttonsGroupedItemDrag;
            context: { type: section.type, formArray: section.formArray }
          "></ng-template>
      </div>
    </div>
  </ng-container>
</form>

<ng-template #buttonsGroupedItemDrag let-type="type" let-formArray="formArray">
  <div [formGroup]="buttonsGrouped">
    <ng-template *ngTemplateOutlet="buttonsGroupedByType; context: { type: type, formArray: formArray }"></ng-template>
    <div class="add-buttons">
      <mat-icon
        *ngIf="type === KakaotalkTemplateButtonTypeEnum.URL"
        [class.disabled]="cannotAddButton"
        class="add-url-btn"
        (click)="addUrlButton()">
        add_circle_outline
      </mat-icon>
    </div>
  </div>
</ng-template>

<ng-template #buttonsGroupedByType let-type="type" let-formArray="formArray">
  <div class="button-details" *ngFor="let buttonForm of formArray.controls; let i = index">
    <div *ngIf="type === formArray.controls[i].value.type" class="d-flex">
      <!-- The common field displayed whatever the type is. -->
      <mat-form-field class="button-label">
        <mat-label
          [translate]="'parameters/kakaotalk-templates/content/buttons/label'"
          [translateParams]="{ i: i + 1 }"></mat-label>
        <input
          matInput
          [maxlength]="limitations.maxLength.button"
          [formControl]="$any(formArray.controls[i].get('text'))" />
        <mat-icon class="remove-button-btn" [class.disabled]="form.disabled" matPrefix (click)="deleteButton(i, type)">
          remove_circle_outline
        </mat-icon>
        <span class="text-muted" matSuffix>
          {{ formArray.controls[i].get('text').value?.length || 0 }}/{{ limitations.maxLength.button }}
        </span>
      </mat-form-field>

      <!-- The extra field related to the URL. -->
      <ng-container *ngIf="formArray.controls[i].value.type === KakaotalkTemplateButtonTypeEnum.URL">
        <mat-form-field
          class="button-url"
          *ngIf="{
            urlControl: formArray.controls[i].get('url'),
            exampleControl: formArray.controls[i].get('example')
          } as urlGroup">
          <mat-label
            translate="parameters/kakaotalk-templates/content/buttons/label/url"
            [translateParams]="{ i: i + 1 }"></mat-label>
          <input #urlInput matInput [maxlength]="limitations.maxLength.url" [formControl]="$any(urlGroup.urlControl)" />
          <mat-icon matPrefix> open_in_new </mat-icon>
          <span class="text-muted" matSuffix> {{ urlInput.value?.length || 0 }}/{{ limitations.maxLength.url }} </span>
          <mat-hint translate="parameters/kakaotalk-templates/content/buttons/label/url/hint"></mat-hint>
        </mat-form-field>
      </ng-container>

      <mat-form-field *ngIf="urlPlaceholders[formArray.controls[i].getRawValue()?.url]">
        <mat-label
          translate="parameters/kakaotalk-templates/content/body/placeholders/example"
          [translateParams]="{ i: 1 }"></mat-label>
        <input #exampleInput matInput [formControl]="$any(formArray.controls[i].get('example'))" />
        <span class="text-muted" matSuffix>
          {{ exampleInput.value?.length || 0 }}/{{ limitations.maxLength.example }}
        </span>
        <mat-hint>{{ getUrlPreview(formArray.controls[i]) }}</mat-hint>
      </mat-form-field>
    </div>
  </div>
</ng-template>

<!-- The differents sections (En-tête, Corps, Pied de page, Boutons) -->
<ng-template #sectionHeader let-label="label" let-optional="optional">
  <section>
    <div>
      <span [translate]="'parameters/kakaotalk-templates/content/' + label + '/title'"></span>&nbsp;
      <small
        *ngIf="optional"
        class="text-muted"
        [translate]="'parameters/kakaotalk-templates/content/optional'"></small>
    </div>
  </section>
</ng-template>
